import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor() {}
  savedata(value: string, cCode: string, dob: string, card: string, fcm: string, ipadress: string) {
    const myObj = {
      dateBirth: dob,
      countryCode: cCode,
      cardNumber: JSON.parse(value).policyHolderCompleteCardNumber.replace("-",""),
      completeCard: JSON.parse(value).policyHolderCompleteCardNumber,
      fcmToken: sessionStorage.getItem('fcmToken'),
      ip: sessionStorage.getItem('ip'),
    };
    sessionStorage.setItem('user', value);
    sessionStorage.setItem('data', JSON.stringify(myObj));
    sessionStorage.setItem('dependents', JSON.stringify(JSON.parse(value).dependents));
    sessionStorage.setItem('setOfProviders', JSON.stringify(JSON.parse(value).setOfProviders));
  }
  saveParam(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }
  getParam(key: string) {
    return sessionStorage.getItem(key);
  }
  async getvvalueSession(key: string, value: string): Promise<string> {
    return JSON.parse(sessionStorage.getItem(key))[value];
  }
  async getData(key: string): Promise<string> {
    return JSON.parse(sessionStorage.getItem(key));
  }
}
